export enum HtmlType {
  Button = 'button',
  Email = 'email',
  Password = 'password',
  Reset = 'reset',
  Submit = 'submit',
  PhoneNumber = 'tel',
  Text = 'text',
}
